<style lang="scss">




@media screen and (min-width: 55rem) {
  .aboutshopping {
    margin-top: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    .aboutshopping-container {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .aboutshopping-title {
        font-size: 2.4rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: bold;
        color: #353535;
      }
      .aboutshopping-subtitle {
        font-size: 1.2rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 400;
        color: #7d7d7d;
      }
      .aboutshopping-block-list {
        display: flex;
        flex-direction: row;
        justify-items: flex-start;
        align-items: center;
        margin-top: 1rem;
        margin-bottom: 3rem;
        .aboutshopping-block-item {
          width: 28px;
          height: 5px;
          background: #e5004f;
          margin-left: 0.2rem;
        }
      }
      .aboutshopping-text-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-content: flex-start;
        .aboutshopping-text-item {
          color: #4b4b4b;
          font-size: 1.4rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          margin-top: 1rem;
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .aboutshopping {
    margin-top: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    .aboutshopping-container {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .aboutshopping-title {
        font-size: 2.4rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: bold;
        color: #353535;
      }
      .aboutshopping-subtitle {
        font-size: 1.2rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 400;
        color: #7d7d7d;
      }
      .aboutshopping-block-list {
        display: flex;
        flex-direction: row;
        justify-items: flex-start;
        align-items: center;
        margin-top: 1rem;
        margin-bottom: 3rem;
        .aboutshopping-block-item {
          width: 28px;
          height: 5px;
          background: #e5004f;
          margin-left: 0.2rem;
        }
      }
      .aboutshopping-text-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-content: flex-start;
        .aboutshopping-text-item {
          color: #4b4b4b;
          font-size: 1.4rem;
          font-family:  'PingFang SC','Microsoft YaHei';
        }
      }
    }
  }
}
</style>

<template>
  <div class="aboutshopping">
    <div class="aboutshopping-container">
      <div class="aboutshopping-title">银泰式服务</div>
      <div class="aboutshopping-subtitle">"INTIME SHOPPING"</div>
      <div class="aboutshopping-block-list">
        <div class="aboutshopping-block-item"></div>
        <div class="aboutshopping-block-item"></div>
        <div class="aboutshopping-block-item"></div>
      </div>

      <div class="aboutshopping-text-list">
        <div class="aboutshopping-text-item">
          银泰百货从出行、物流、会员服务、首店等各个方面，不断为顾客提升和改善消费服务体验。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "title",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
